/* eslint-disable react/prop-types */
import React from 'react'
import LocationContext from './locationContext'
import { useLocation } from '@/custom/hooks/useLocationFilter'

const LocationState = (props) => {
    const location = useLocation()

    return <LocationContext.Provider value={location}>{props.children}</LocationContext.Provider>
}

export default LocationState
